import { IUserStatsData } from "api/individual/types";

export enum IndividualComplianceQueryKeys {
  INDIVIDUAL_STATS = "individualStatistics",
  INDIVIDUALS_LIST = "individualsList",
  INDIVIDUAL_DETAILS = "individualDetails",
  INDIVIDUAL_APPROVAL = "individualApproval",
  INDIVIDUAL_REJECTION = "individualRejection",
  FACE_VERIFICATION = "faceVerification",
  RESET_USER_BVN = "resetUserBvn",
  APPROVE_INDIVIDUAL_COMPLIANCE = "approveIndividualCompliance",
  APPROVE_ADDRESS_VERIFICATION = "approveAddressVerification",
  REJECT_ADDRESS_VERIFICATION = "rejeectAddressVerification",
}

export const DEFAULT_USER_STATS: IUserStatsData = {
  total: 0,
  active: 0,
  inActive: 0,
  inReview: 0,
  inRejected: 0,
};

export const DEFAULT_INDIVIDUAL_DETAILS = {
  id: "",
  firstName: "",
  lastName: "",
  email: "",
  profileImage: "",
  accountTier: 0,
  phoneNumber: "",
  createdAt: "",
  updatedAt: "",
  accountName: "",
  accountNumber: "",
  bvnReference: "",
  dob: "",
  bvn: "",
  nin: "",
  kycDocumentType: null,
  bvnValidated: false,
  ninValidated: false,
  isFinalResult: null,
  kycAddressVerificationFile: null,
  kycJobId: null,
  kycVerifyDocument: null,
  kycResultText: null,
  kycJobStatus: null,
  kycLivenessCheck: null,
  kycProofOfAddressType: "",
  adminKycComment: [],
  employmentDetails: null,
  addressApprovedAt: null,
  adminDeleteComment: [],
  points: 0,
  address: "",
  state: "",
  lga: "",
  lastLogin: "",
  adminVerify: false,
  kycStatus: "",
  addressKycStatus: "",
};
